module.exports = __webpack_public_path__ + "static/media/joseph_moon.eb9e4ceb.png";